const event = function (name) {
  var evt = document.createEvent('Event')
  evt.initEvent(name, true, true)
  return evt
}

export const upperCase = {
  update: function (el) {
    el.value = el.value.toUpperCase()
    el.dispatchEvent(event('input'))
  },

  inserted: function (el) {
    upperCase.update(el)
  }
}

export const zeroBefore = {
  update: function (el) {
    const maxLength = el.maxLength

    if (+el.value > 0 && `${ +el.value }`.length < maxLength) {
      const value = el.value.replace(0, '')
      const missing = maxLength - value.length
      let newValue = ''

      for (let i = 0; i < missing; i++) {
        newValue += '0'
      }

      newValue = `${newValue + value}`.split('').slice(0, maxLength).join('')

      if (+newValue > 0) {
        el.value = newValue
      }
    } else {
      el.value = `${ +el.value }`.split('').slice(0, maxLength).join('')
    }
    el.dispatchEvent(event('input'))
  },

  inserted: function (el) {
    zeroBefore.update(el)
  }
}

function selectHighlightedOption (target) {
  let highlightedOption = null

     highlightedOption = target.querySelector(".multiselect__option--highlight") ||
      target.querySelector("[data-selected='Selected']")


  if (highlightedOption) {
    highlightedOption.dispatchEvent(new Event("click"))
  }
}

export const onLeavingSelect = {
  inserted: function (el) {
    let list = el.querySelector("ul")
    let items = null

    if (list) {
      items = list.querySelectorAll("li")
    }

    if (items && items.length > 4) {

      let input = el.querySelector(".multiselect__input")
      if (input) {
        input.addEventListener("keydown", async (ev) => {

          if (ev.keyCode === 9) {

            selectHighlightedOption(el)
            ev.preventDefault()

            document.dispatchEvent(new Event("keypress", {keyCode: 9}))
          }
        })
      } else {
        el.addEventListener("focusout", () => {
          selectHighlightedOption(el)
        })
      }

    } else {

      let observer = new MutationObserver((mutationRecordList) => {
        let finalTarget = mutationRecordList[0].target

        el.addEventListener("focusout", () => {
          selectHighlightedOption(finalTarget)
        })

      })

      let config = { attributes: true, childList: true, characterData: true }

      if (list)
        observer.observe(list, config)
    }

  }
}
/**
 * @author Franklin V. Oliveira @processmind
 * Recebe [value] o valor da opção deseja
 *  v-selected-option=value
 * se value não for fornecido, seleciona a primeira opçao do select
 */

export const selectedOption = {
  bind: function (el, binding) {
    selectOption(el, binding.value)
  }
}

let selectOption = (el, value) => {
  let selectedIndex = [...el.options].findIndex((opt) => parseInt(opt.value) === parseInt(value))

  if (selectedIndex < 0 || (selectedIndex + 1) > el.options.length) {
    selectedIndex = 0
  }

  el.selectedIndex = selectedIndex
  el.options[selectedIndex].dispatchEvent(new Event("click"))
  el.dispatchEvent(new Event("change"))
}
